<ng-container
  *ngIf="{
    product: product$ | async,
    isLogged: isLogged$ | async,
  } as content"
>
  @if (!content.product?.discontinued) {
    <div class="container-product-price" [ngClass]="{ 'is-logged': content.isLogged, 'has-your-price': content.product?.yourPrice }">
      @if (content.isLogged) {
        @if (content.product?.price) {
          <p class="list-price">
            <span class="title"> {{ 'productPrice.listPrice' | cxTranslate }}: </span>
            <span class="content">{{ content.product?.price?.formattedValue }}</span>
          </p>
        }

        @if (lazyPrice) {
          <p class="your-price lazy-price">
            @if (!content.product?.thirdPartyPriceStatus?.hasError) {
              <span class="title"> {{ 'productPrice.yourPrice' | cxTranslate }}: </span>
            }

            <span class="content p-l-4">
              @if (!content.product?.thirdPartyPriceStatus?.hasError) {
                @if (content.product?.yourPrice) {
                  {{ content.product?.yourPrice?.formattedValue }}
                } @else {
                  <local-loader></local-loader>
                }
              }
            </span>
          </p>
        } @else {
          @if (content.product?.yourPrice) {
            <p class="your-price">
              <span class="title"> {{ 'productPrice.yourPrice' | cxTranslate }}: </span>
              <span class="content">{{ content.product?.yourPrice?.formattedValue }}</span>
            </p>
          }
        }

        @if (content.product?.differencePrice && content.product?.price) {
          <p class="diference">
            <span class="title"> {{ 'productPrice.difference' | cxTranslate }}: </span>
            <span class="content">
              @if (content.product?.differencePrice?.value! > 0) {
                {{ content.product?.differencePrice?.formattedValue }}
              } @else {
                -
              }
            </span>
          </p>
        }
      } @else {
        @if (content.product?.price) {
          <p class="list-price">
            <span class="title"> {{ 'productPrice.listPrice' | cxTranslate }}: </span>
            <span class="content">{{ content.product?.price?.formattedValue }}</span>
          </p>
        }
        <p class="require-login">
          {{ 'productPrice.yourPrice' | cxTranslate }}: <a [routerLink]="['/login']"> {{ 'productPrice.loginRequired' | cxTranslate }} </a>
        </p>
      }
    </div>
  }
</ng-container>
